<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="30%"
    @closed="handleAfterClosed"
  >
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="名称：">
        <el-input v-model="form.title" size="small" />
      </el-form-item>
      <el-form-item label="时长">
        <el-input v-model.number="form.duration" size="small" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleOK">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import store from '../../../store/index.js'
import { attrWebPage } from '../../../utils/component-attribute'

export default {
  title: 'AddWebPage',
  inject: ['getNewComponentId'],
  data() {
    return {
      form: { title: undefined, duration: undefined },
      rules: {
        title: [
          { required: true, message: '请输入场景名称', trigger: 'blur' }
        ],
        duration: [
          { required: false, min: 1, max: Number.MAX_SAFE_INTEGER, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return store.state.editPageDialogVisible
      },
      set(val) {
        store.updateEditPageDialogVisible(val)
      }
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        const page = store.state.programInfo.pages[store.state.editPageIdx]
        this.form.title = page.title
        this.form.duration = page.duration
      }
    }
  },
  methods: {
    handleAfterClosed() {
      this.form = { title: undefined, duration: undefined }
    },
    handleClickAdd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const conf = JSON.parse(JSON.stringify(attrWebPage))
          conf.componentId = this.getNewComponentId()
          conf.url = this.form.url
          store.addComponent(conf)
          this.dialogVisible = false
        }
      })
    },
    handleOK() {
      this.$refs.form.validate(valid => {
        if (valid) {
          store.setPageInfo(this.form.title, this.form.duration)
          this.dialogVisible = false
        }
      })
    }
  }
}
</script>
